import type { ClassroomCommandInput, ClassroomSection, ClassroomRole } from "./types.ts";

export const classroomRoles: ClassroomRole[] = ["STUDENT", "TEACHER", "SUPERVISOR"];
export function classroomCommandBody(input: ClassroomCommandInput, section: ClassroomSection | null, requestId: string) {
  if (input.action !== "create" && !section) throw new Error("Section required");
  return { ...input, ...(input.action === "create" ? {} : { sectionId: section!.sectionId, expectedVersion: section!.version }), requestId };
}
export function classroomMediaUrl(value?: string): string | undefined {
  if (!value) return undefined;
  try { const url = new URL(value); return url.protocol === "https:" ? url.href : undefined; } catch { return undefined; }
}
export function classroomDate(value: string | undefined, language: string): string {
  const date = value ? new Date(value) : undefined;
  return date && Number.isFinite(date.getTime()) ? new Intl.DateTimeFormat(language === "ar" ? "ar-JO" : "en-GB", { dateStyle: "medium", timeStyle: "short" }).format(date) : "—";
}
